<template>
    <div class="goldCoinBattle-wrapper position-relative">
        <div class="goldCoinBattle_topBanner_section position-relative text-center">
            <div class="goldCoinBattle_topHeader position-relative d-flex justify-content-between align-items-center">
                <!-- <div class="angle backIcon cursor-pointer" @click="viewClose('someStatus')"></div> -->
                 <div class="angle backIcon cursor-pointer" @click="viewClose('backPage')"></div>
                <!-- <div class="infoIcon_box cursor-pointer" @click="showRulesPopup">
                    <img :src='white_infoIcon' alt="" />
                </div> -->
                <div class="giftReward_iconBox" @click="showRewardsPopup">
                    <img :src='gift_reward_icon' class="giftReward_icon" alt="" />
                    <span>Reward</span>
                </div>
            </div>
            <img :src='GoldCoinBattle_topBannerImage' class="goldCoinBattle_top_bgBanner" alt="" />
            <img :src='GoldCoinBattle_topPattern_BGImage' class="GoldCoinBattle_topPattern_BGImage" alt="" />
            <img :src='goldCoinBattle_logoImage' class="goldCoinBattle_logo" alt="" />
            <div>
                <DayHrsCounter />
            </div>
        </div>
        <div class="goldCoinBattle_totalReward_box goldCoinBattle_rewardSection position-relative">
            <div class="goldCoinBattle_totalHeaderBox bg_05_opacity d-flex align-items-center justify-content-center">
                <!-- <img :src='GoldCoinBattle_todayReward_Border_image' alt="" /> -->
                <div class="goldCoinBattle_totalRewardBox">
                    <div class="goldCoinBattle_totalReward_HD text-center text-white">{{ rewardTitle }}</div>
                    <div class="d-flex justify-content-center align-items-center gap-1 text-center"
                        v-if="goldCoinBattleTotalReward && goldCoinBattleTotalReward">
                        <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleTotalReward }}</div>
                        <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                    </div>
                </div>
                <!-- <img :src='gift_reward_icon' class="giftReward_icon" @click="showRewardsPopup" alt="" /> -->
                <div class="goldCoinBattle_infoIcon_box cursor-pointer" @click="showRulesPopup">
                    <img :src='white_infoIcon' alt="" />
                </div>
                <!-- <img :src='GoldCoinBattle_todayReward_prevBorder_image' alt="" /> -->
            </div>
            <!-- <div class="goldCoinBattle_podiumBox goldCoinBattle_rewardBoxes position-relative">
                <img :src='GoldCoinBattle_podiumImage' alt="" />
                <div class="goldCoinBattle_top_rewardBox">
                    <div class="goldCoinBattle_rewardBox rewardBox2"
                        v-if="goldCoinBattleRewards && goldCoinBattleRewards[1]">
                        <div
                            class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[1].reward_coin }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                    <div class="goldCoinBattle_rewardBox rewardBox1"
                        v-if="goldCoinBattleRewards && goldCoinBattleRewards[0]">
                        <div
                            class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[0].reward_coin }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                    <div class="goldCoinBattle_rewardBox rewardBox3"
                        v-if="goldCoinBattleRewards && goldCoinBattleRewards[2]">
                        <div
                            class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[2].reward_coin }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                </div>
                <div class="goldCoinBattle_rewardVal_listWrap">
                    <div class="goldCoinBattle_rewardValBox" v-if="goldCoinBattleRewards && goldCoinBattleRewards[3]">
                        <div class="goldCoinBattle_reward_no_lvl text-center text-white">4th to 6th</div>
                        <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[3].reward_coin }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                    <div class="goldCoinBattle_rewardValBox" v-if="goldCoinBattleRewards && goldCoinBattleRewards[4]">
                        <div class="goldCoinBattle_reward_no_lvl text-center text-white">7th to 10th</div>
                        <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[6].reward_coin }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="goldCoinBattle_listWrapper">
            <div
                class="goldCoinBattle_listHeading-box position-relative d-flex align-items-center justify-content-between text-center text-white">
                <!-- Prev -->
                <div class="angle previous_angle" :class="{ 'is-disabled': currentIndex === 1 || loading }"
                    @click="prevTab" role="button" aria-label="Previous (Yesterday)"></div>

                <div>{{ typeLabel }}</div>

                <!-- Next -->
                <div class="angle next_angle" :class="{ 'is-disabled': currentIndex === 0 || loading }" @click="nextTab"
                    role="button" aria-label="Next (Today)"></div>
            </div>
            <div class="goldCoinBattle_listWrap">
                <div class="fixHeight goldCoinBattle_listBoxes mt-0">
                    <div v-if="loading" class="p-3 text-center text-white">Loading…</div>
                    <div v-else-if="!goldCoinGroupBattleData.length" class="p-3 text-center text-white">
                        No data found.
                    </div>
                    <!-- List -->
                    <div v-else class="listBoxes" v-for="(row, idx) in goldCoinGroupBattleData"
                        :key="row.user_id || idx"
                        @click="redirectProfile(row.userdata.id, row.userdata.profile_id, row.userdata.rich_level)">
                        <div class="leftBxb">
                            <div class="s-no">{{ idx + 1 }}</div>
                            <div class="listIconBox">
                                <div class="profPic">
                                    <img :src="getProfileImage(row)" alt="User Image" @error="onImgError" />
                                </div>
                            </div>

                            <div class="name-lavel-box">
                                <div class="userName">{{ row.userdata?.name || 'Unknown' }}</div>
                                <div class="d-flex align-items-center gap-2">
                                    <div class="lavel-box">
                                        <img :src="getLevelImage(row.userdata?.rich_level || 0)" class="lavelImage"
                                            alt="level icon" />
                                        <span class="lavel-value">{{ row.userdata?.rich_level ?? 0 }}</span>
                                    </div>
                                    <div class="notEligible-btn" v-if="(row.reward_coin > 0) && (row.gold_coin_count < 50)">Not Eligible</div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="rightBox">
                            <div class="rightBox-in">
                                <div
                                    class="starmateGoldCoin-valBox d-flex align-items-center justify-content-end gap-1">
                                    <div>{{ row.gold_coin_count ?? 0 }}</div>
                                    <img :src="starmateGoldCoinIcon" class="diamondIcon m-0" alt="gold coin icon" />
                                </div>
                                <div class="goldCoinBattle_rewardVal mt-1" v-if="(row?.reward_coin ?? 0) > 0">Reward: {{
                                    row.reward_coin ?? 0 }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="listBoxes goldCoinBattle_selfData text-white"
                    v-if="goldCoinBattleSelfData && Object.keys(goldCoinBattleSelfData).length"
                    @click="redirectProfile(goldCoinBattleSelfData.id, goldCoinBattleSelfData.profile_id, goldCoinBattleSelfData.rich_level)">
                    <div class="leftBxb">
                        <div class="s-no text-white">{{ goldCoinBattleSelfData.rank > 0 ? goldCoinBattleSelfData.rank : '-' }}</div>
                        <div class="listIconBox">
                            <div class="profPic">
                                <img :src="getProfileImage(goldCoinBattleSelfData)" alt="User Image"
                                    @error="onImgError" />
                            </div>
                        </div>
                        <div class="name-lavel-box">
                            <div class="userName text-white">{{ goldCoinBattleSelfData.name || ' ' }}</div>
                            <div class="d-flex align-items-center gap-2">
                                <div class="lavel-box">
                                    <img :src="getLevelImage(goldCoinBattleSelfData?.rich_level || 0)" class="lavelImage"
                                        alt="level icon" />
                                    <span class="lavel-value">{{ goldCoinBattleSelfData?.rich_level ?? 0 }}</span>
                                </div>
                                <div class="notEligible-btn" v-if="(goldCoinBattleSelfData.reward_coin > 0) && (goldCoinBattleSelfData.gold_coin_count < 50)">Not Eligible</div>
                            </div>
                        </div>
                    </div>
                    <div class="rightBox">
                        <div class="rightBox-in">
                            <div class="starmateGoldCoin-valBox d-flex align-items-center justify-content-end gap-1">
                                <div class="text-white">{{ goldCoinBattleSelfData.gold_coin_count ?? 0 }}</div>
                                <img :src="starmateGoldCoinIcon" class="diamondIcon m-0" alt="gold coin icon" />
                            </div>
                            <!-- <div class="goldCoinBattle_rewardVal mt-1 text-white"
                                v-if="(goldCoinBattleSelfData?.reward_coin ?? 0) > 0">
                                Reward: {{ goldCoinBattleSelfData.reward_coin }}
                            </div> -->
                        </div>
                        <div class="goldCoinBattle_rewardVal mt-1 text-white" v-if="(goldCoinBattleSelfData.reward_coin>0)">Reward: {{ goldCoinBattleSelfData.reward_coin }}</div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Info popup -->
        <div class="mode-area" v-show="isPopupOverlayVisible" @click="showRulesPopup"></div>
        <div id="rulesPopup"
            :class="{ 'goldCoinbattleRule_popup popup_box': true, 'rule-pop-up': true, 'transform-in': rulesPopupVisible, 'transform-out': !rulesPopupVisible }">            
            
            <div class="goldCoinBattle_totalHeaderBox d-flex align-items-center justify-content-center">
                <img :src='GoldCoinBattle_todayReward_Border_image' alt="" />
                <div class="goldCoinBattle_totalRewardBox">
                    <div class="goldCoinBattle_totalReward_HD text-center">Rules</div>
                </div>
                <img :src='GoldCoinBattle_todayReward_prevBorder_image' alt="" />
            </div>

            <!-- <div class="">
                <div class="rulePopup-topHD"></div>
            </div> -->
            <div class="rule-popupBody">
                <div class="rule-content">
                    <ol class="rule-secCont">
                        <li><b>Daily Battle Time</b>: 00:00 – 23:59 (UTC +5:30).</li>
                        <li><b>Top 20 winners</b> will receive daily rewards.</li>
                        <li><b>Ranking</b> is based on number of Gold Coins send.</li>
                        <li><b>Rewards</b> will be credited automatically the next day. <br />
                            A minimum of <b>50 Gold</b> Coins must be sent to be eligible for rewards.</li>
                        <li><b>Only one account per device</b> is eligible. Deleted, banned, or abnormal accounts are not allowed.</li>
                        <li><b>Eligible Games</b>: All games except the Fishing Star and Airforce Star.</li>
                        <li><b>Unfair or fake activity</b> will lead to disqualification.</li>
                    </ol>
                </div>
            </div>
        </div>

        <!-- Reward popup -->
        <div class="mode-area" v-show="isRewardsPopupOverlayVisible" @click="showRewardsPopup"></div>
        <div id="rulesPopup"
            :class="{ 'goldCoinbattleRewards_popup popup_box pb-4': true, 'rule-pop-up': true, 'transform-in': rewardsPopupVisible, 'transform-out': !rewardsPopupVisible }">            
            
            <!-- <div class="goldCoinBattle_totalHeaderBox d-flex align-items-center justify-content-center">
                <img :src='GoldCoinBattle_todayReward_Border_image' alt="" />
                <div class="goldCoinBattle_totalRewardBox">
                    <div class="goldCoinBattle_totalReward_HD text-center">Rules</div>
                </div>
                <img :src='GoldCoinBattle_todayReward_prevBorder_image' alt="" />
            </div>
            <div class="rule-popupBody">
                <div class="rule-content">
                    <h1>Rewards Popup</h1>
                </div>
            </div> -->

            <div class="goldCoinBattle_rewardSection position-relative">
                <div class="goldCoinBattle_totalHeaderBox d-flex align-items-center justify-content-center">
                    <img :src='GoldCoinBattle_todayReward_Border_image' alt="" />
                    <div class="goldCoinBattle_totalRewardBox">
                        <div class="goldCoinBattle_totalReward_HD text-center text-white">{{ rewardTitle }}</div>
                        <div class="d-flex justify-content-center align-items-center gap-1 text-center"
                            v-if="goldCoinBattleTotalReward && goldCoinBattleTotalReward">
                            <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleTotalReward }}</div>
                            <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                        </div>
                    </div>
                    <img :src='GoldCoinBattle_todayReward_prevBorder_image' alt="" />
                </div>
                <div class="goldCoinBattle_podiumBox goldCoinBattle_rewardBoxes position-relative">
                    <img :src='GoldCoinBattle_podiumImage' alt="" />
                    <div class="goldCoinBattle_top_rewardBox">
                        <div class="goldCoinBattle_rewardBox rewardBox2"
                            v-if="goldCoinBattleRewards && goldCoinBattleRewards[1]">
                            <div
                                class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                                <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[1].reward_coin }}</div>
                                <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                            </div>
                        </div>
                        <div class="goldCoinBattle_rewardBox rewardBox1"
                            v-if="goldCoinBattleRewards && goldCoinBattleRewards[0]">
                            <div
                                class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                                <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[0].reward_coin }}</div>
                                <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                            </div>
                        </div>
                        <div class="goldCoinBattle_rewardBox rewardBox3"
                            v-if="goldCoinBattleRewards && goldCoinBattleRewards[2]">
                            <div
                                class="goldCoinBattle_rewardValBox d-flex justify-content-center align-items-center gap-1 text-center">
                                <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[2].reward_coin }}</div>
                                <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="goldCoinBattle_rewardVal_listWrap">
                        <div class="goldCoinBattle_rewardValBox" v-if="goldCoinBattleRewards && goldCoinBattleRewards[3]">
                            <div class="goldCoinBattle_reward_no_lvl text-center text-white">4th to 10th</div>
                            <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                                <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[3].reward_coin }}</div>
                                <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                            </div>
                        </div>
                        <div class="goldCoinBattle_rewardValBox" v-if="goldCoinBattleRewards && goldCoinBattleRewards[12]">
                            <div class="goldCoinBattle_reward_no_lvl text-center text-white">11th to 20th</div>
                            <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                                <div class="goldCoinBattle_rewardVal">{{ goldCoinBattleRewards[12].reward_coin }}</div>
                                <img :src='diamondIcon' class="diamondIcon m-0" alt="" />
                            </div>
                        </div>
                    </div> -->



                    <!-- <div class="goldCoinBattle_rewardVal_listWrap">
                        <div
                            class="goldCoinBattle_rewardValBox"
                            v-for="(g, i) in rewardListForPopup"
                            :key="i"
                        >
                            <div class="goldCoinBattle_reward_no_lvl text-center text-white">
                            {{ g.label }}
                            </div>

                            <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ g.reward }}</div>
                            <img :src="diamondIcon" class="diamondIcon m-0" />
                            </div>
                        </div>
                    </div> -->


                    <div class="goldCoinBattle_rewardVal_listWrap">
                        <div
                            class="goldCoinBattle_rewardValBox mb-2"
                            :class="{ goldCoinBattle_reward_fullWidth_box: isLastOddBox(i) }"
                            v-for="(g, i) in rewardListForPopup"
                            :key="i"
                        >
                            <div class="goldCoinBattle_reward_no_lvl text-center text-white">
                            {{ g.label }}
                            </div>

                            <div class="d-flex justify-content-center align-items-center gap-1 text-center">
                            <div class="goldCoinBattle_rewardVal">{{ g.reward }}</div>
                            <img :src="diamondIcon" class="diamondIcon m-0" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>
    </div>
</template>

<script>
import axios from 'axios'
import './GoldCoinBattle.css'
import DayHrsCounter from '../DayHrsCounter.vue'
import starmateGoldCoinIcon from '../../assets/images/goldCoinBattle/starmateGoldCoinIcon.webp'
import GoldCoinBattle_topPattern_BGImage from '../../assets/images/goldCoinBattle/GoldCoinBattle_topPattern_BGImage.webp'
import GoldCoinBattle_topBannerImage from '../../assets/images/goldCoinBattle/GoldCoinBattle_topBannerImage.webp'
import GoldCoinBattle_podiumImage from '../../assets/images/goldCoinBattle/GoldCoinBattle_podiumImage.webp'
import goldCoinBattle_logoImage from '../../assets/images/goldCoinBattle/goldCoinBattle_logoImage.webp'
import GoldCoinBattle_timerBg_box from '../../assets/images/goldCoinBattle/goldCoinBattle_timeBox.svg'
import GoldCoinBattle_todayReward_Border_image from '../../assets/images/goldCoinBattle/GoldCoinBattle_todayReward_Border_image.svg'
import GoldCoinBattle_todayReward_prevBorder_image from '../../assets/images/goldCoinBattle/GoldCoinBattle_todayReward_prevBorder_image.svg'
import defaultUserImage from '../../assets/images/default_profile.webp';
import diamondIcon from '../../assets/images/diamond-icon.png'
import white_infoIcon from '../../assets/images/goldCoinBattle/white_infoIcon.png'
import gift_reward_icon from '../../assets/images/goldCoinBattle/gift_reward_icon.png'

export default {
    name: 'GoldCoinBattle',
    components: {
        DayHrsCounter
    },
    data() {
        return {
            // UI / state
            currentIndex: 0, // 0 => today, 1 => yesterday
            loading: false,
            goldCoinGroupBattleData: [],
            goldCoinBattleRewards: [],
            goldCoinBattleTotalReward: null,
            goldCoinBattleSelfData: {},

            // assets
            starmateGoldCoinIcon,
            GoldCoinBattle_topPattern_BGImage,
            GoldCoinBattle_topBannerImage,
            GoldCoinBattle_podiumImage,
            goldCoinBattle_logoImage,
            GoldCoinBattle_timerBg_box,
            GoldCoinBattle_todayReward_Border_image,
            GoldCoinBattle_todayReward_prevBorder_image,
            defaultUserImage,
            diamondIcon,
            white_infoIcon,
            gift_reward_icon,

            rulesPopupVisible: false,
            isPopupOverlayVisible: false,

            rewardsPopupVisible: false,
            isRewardsPopupOverlayVisible: false,
        }
    },
    computed: {
        typeLabel() {
            return this.currentIndex === 0 ? 'TODAY' : 'YESTERDAY'
        },
        apiType() {
            return this.currentIndex === 0 ? 'today' : 'yesterday'
        },
        rewardTitle() {
            return this.apiType === 'today' ? "Today’s Reward" : "Yesterday’s Reward"
        },
        authToken() {
            return this.$route?.query?.token || this.$route?.params?.token || ''
        },

        // group rewards from rank 4+ by reward_coin
        groupedRewardRanges() {
        if (!Array.isArray(this.goldCoinBattleRewards)) return []

        const byCoin = {}

        this.goldCoinBattleRewards.forEach(item => {
            if (!item || item.rank == null) return

            // skip top 3 (1st, 2nd, 3rd - already shown on podium)
            if (item.rank <= 3) return

            const key = item.reward_coin
            if (!byCoin[key]) byCoin[key] = []
            byCoin[key].push(item.rank)
        })

        const groups = Object.entries(byCoin).map(([coin, ranks]) => {
            ranks.sort((a, b) => a - b)
            const fromRank = ranks[0]
            const toRank = ranks[ranks.length - 1]

            return {
            reward: Number(coin),
            fromRank,
            toRank,
            label:
                fromRank === toRank
                ? this.formatOrdinal(fromRank)
                : `${this.formatOrdinal(fromRank)} to ${this.formatOrdinal(toRank)}`
            }
        })

        // Ensure they appear sorted from smallest rank (4th, 7th, etc.)
        return groups.sort((a, b) => a.fromRank - b.fromRank)
        },

        // list used in template
        rewardListForPopup() {
        // you can further filter here if needed, currently already rank >= 4
        return this.groupedRewardRanges
        }
    },
    watch: {
        '$route.fullPath'() {
            this.fetchGoldCoinGroupBattleData()
        }
    },
    mounted() {
        this.fetchGoldCoinGroupBattleData()
    },
    methods: {
        // ordinal helper: 1 -> 1st, 2 -> 2nd, 3 -> 3rd, 4 -> 4th, etc.
        formatOrdinal(n) {
            const s = ["th", "st", "nd", "rd"]
            const v = n % 100
            return n + (s[(v - 20) % 10] || s[v] || s[0])
        },
        isLastOddBox(index) {
            const len = this.rewardListForPopup.length
            // if odd number of boxes and this is the last one → full width
            return len % 2 === 1 && index === len - 1
        },
        
        showRulesPopup () {
            this.rulesPopupVisible = !this.rulesPopupVisible
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
        },

        showRewardsPopup () {
            this.rewardsPopupVisible = !this.rewardsPopupVisible
            this.isRewardsPopupOverlayVisible = !this.isRewardsPopupOverlayVisible;
        },

        prevTab() {
            if (this.currentIndex !== 1) {
                this.currentIndex = 1
                this.fetchGoldCoinGroupBattleData()
            }
        },
        nextTab() {
            if (this.currentIndex !== 0) {
                this.currentIndex = 0
                this.fetchGoldCoinGroupBattleData()
            }
        },

        // ---- API ----
        async fetchGoldCoinGroupBattleData() {
            try {
                this.loading = true

                const apiUrl = `/api/top-gold-coin-ranking-list?type=${this.apiType}`

                const headers = {}
                if (this.authToken) {
                    headers['Authorization'] = `Bearer ${this.authToken}`
                }

                const { data } = await axios.get(apiUrl, { headers })
                const result = data?.result || {}

                this.goldCoinGroupBattleData = Array.isArray(result.data) ? result.data : []
                this.goldCoinBattleRewards = Array.isArray(result.dailyrewards) ? result.dailyrewards : []
                this.goldCoinBattleTotalReward = result?.totalrewards ? Number(result.totalrewards) : 0;
                this.goldCoinBattleSelfData = result?.personaldata || {};
            } catch (err) {
                console.error('Error fetching Group Battle Data:', err)
                this.goldCoinGroupBattleData = []
                this.goldCoinBattleRewards = []
                this.goldCoinBattleSelfData = {}
            } finally {
                this.loading = false
            }
        },

        // ---- helpers ----
        getProfileImage(row) {
            const list = row?.userdata?.profile_images || row?.profile_images || []
            return list.length ? list[0].image_name : defaultUserImage
        },
        onImgError(e) {
            e.target.src = defaultUserImage
        },
        getLevelImage(rich_lavel) {
            switch (true) {
                case rich_lavel === 0:
                return require('@/assets/images/rich-lavel-0.png');
                case rich_lavel === 1:
                return require('@/assets/images/rich-lavel-1.png');
                case rich_lavel >= 2 && rich_lavel <= 10:
                return require('@/assets/images/rich-lavel-2.png');
                case rich_lavel >= 11 && rich_lavel <= 20:
                return require('@/assets/images/rich-lavel-3.png');
                case rich_lavel >= 21 && rich_lavel <= 30:
                return require('@/assets/images/rich-lavel-5-8.png');
                case rich_lavel >= 31 && rich_lavel <= 40:
                return require('@/assets/images/rich-lavel-12.png');
                case rich_lavel >= 41 && rich_lavel <= 50:
                return require('@/assets/images/rich-lavel-15.png');
                
                // case rich_lavel === 0:
                //     return require('@/assets/images/rich-lavel-0.png')
                // case rich_lavel === 1:
                //     return require('@/assets/images/rich-lavel-1.png')
                // case rich_lavel === 2:
                //     return require('@/assets/images/rich-lavel-2.png')
                // case rich_lavel === 3:
                //     return require('@/assets/images/rich-lavel-3.png')
                // case rich_lavel === 4:
                //     return require('@/assets/images/rich-lavel-4.png')
                // case rich_lavel >= 5 && rich_lavel <= 8:
                //     return require('@/assets/images/rich-lavel-5-8.png')
                // case rich_lavel >= 9 && rich_lavel <= 11:
                //     return require('@/assets/images/rich-lavel-9-11.png')
                // case rich_lavel === 12:
                //     return require('@/assets/images/rich-lavel-12.png')
                // case rich_lavel === 13:
                //     return require('@/assets/images/rich-lavel-13.png')
                // case rich_lavel === 14:
                //     return require('@/assets/images/rich-lavel-14.png')
                // case rich_lavel === 15:
                //     return require('@/assets/images/rich-lavel-15.png')
                default:
                    return require('@/assets/images/rich-lavel-0.png')
            }
        },
        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = '#';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //console.warn(url)
                Android.redirectProfile(url);
            }
        },
        //Close Webview on back arrow click

        // viewClose(status) {
        //     if (window.navigator.userAgent.indexOf("Android") > -1) {
        //         Android.viewClose(status);
        //     }
        // }

        viewClose(status) {
            // Android native call (only if available)
            const ua = window.navigator.userAgent || "";
            if (ua.includes("Android") && window.Android && typeof window.Android.viewClose === "function") {
                window.Android.viewClose(status);
            }

            // Always go to previous page
            this.$router.go(-1); // same as back(), but explicit
        }
    }
}
</script>

<style scoped>
.is-disabled {
    pointer-events: none;
    opacity: 0.4;
}
</style>
